import { SpherePlatformAppPaths } from '@sphere/platform';

export const PATHS: SpherePlatformAppPaths = {
    ['CRITICAL_LISTS_PATH']: 'critical-lists',
    ['CRL_LIST_PATH']: 'list',
    ['ADNS_LIST_PATH']: 'adns'
};
